<template>
    <div class="background-search q-py-lg">
        <div class="row justify-center">
            <div class="col-4 intel-yellow text-center text-h6">
                {{ $t('search_for_rewards_here_to_redeem_with_your_points') }}
            </div>
        </div>

        <div class="row justify-center q-mt-md">
            <div class="col-4">
                <q-select square outlined dense clearable hide-dropdown-icon v-model="search" use-input hide-selected fill-input :input-debounce="500" :options="options" @filter="seachRewards" :placeholder="$t('search_partners_or_offerings')" bg-color="white">
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section>
                                {{ $t('no_rewards_found') }}
                            </q-item-section>
                        </q-item>
                    </template>

                    <template v-slot:option="scope">
                        <q-item v-bind="scope.itemProps" v-on="scope.itemEvents" @click="selectReward(scope.opt.id)">
                            <q-item-section avatar>
                                <q-img :src="scope.opt.reward_image" />
                            </q-item-section>

                            <q-item-section>
                                <q-item-label>{{ scope.opt.title }}</q-item-label>

                                <q-item-label caption>
                                    {{ getCategory(scope.opt.categories[0]) }}
                                </q-item-label>
                            </q-item-section>

                            <q-item-section side top>
                                {{ scope.opt.price }} {{ $t('point', {count: parseFloat(scope.opt.price)}) }}
                            </q-item-section>
                        </q-item>
                    </template>

                    <template v-slot:prepend>
                        <q-icon name="fal fa-search" />
                    </template>
                </q-select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SearchRewardStoreDesktop',

    data() {
        return {
            search: '',
            options: []
        }
    },

    computed: {
        ...mapGetters({
            reward_categories: 'site_lists/reward_categories'
        })
    },

    methods: {
        seachRewards(val, update, abort) {
            this.options = []

            if (val.length < 2) {
                abort()
                return
            }

            let data = {
                "page_size": 10,
                "page": 1,
                "search": val
            }

            this.$axios.get(`/etraining_rewards/rewards/?${this.$qs.stringify(data)}`)
            .then(response => {
                update(() => {
                    if (this.$route.name === 'reward_details') this.options = response.data.results.map(e => ({ ...e }) ).filter(e => e.id !== this.$route.params.id)
                    else this.options = response.data.results
                })
            })
            .catch(e => {
                console.log(e)
            })
        },

        selectReward(val) {
            this.$router.push({ name: 'reward_details', params: { id: val } })
        },

        getCategory(id) {
            let obj = this.reward_categories.find((obj) => { return obj.id === id })
            if (obj) return obj.title
            else return ''
        }
    }
}
</script>

<style>
</style>
